import CoreIcon from './component'

export default CoreIcon
